<template>
  <button
    type="button"
    class="bg-primary/20 flex cursor-pointer items-center justify-between rounded-full px-3 py-1 text-sm"
  >
    <slot />
  </button>
</template>
